import React from 'react';
import './Specialties.css';

// 顺序即页面顺序：前三项在左列，后三项在右列（手机上按 1 到 6 竖排）
const specialties = [
    {
        title: "Foot Skin Conditions",
        lines: [
            "Corn and callus",
            "Warts (Verruca)",
            "Fungal skin (Tinea-Athlete’s foot)",
            "Cracked heel",
        ],
    },
    {
        title: "Foot Nail Conditions",
        lines: ["Ingrown toenail", "Fungal nail"],
    },
    {
        title: ["Diabetic Foot Assessment and", "Treatment"],
        lines: [],
    },
    {
        title: "Common Foot Pain",
        lines: [
            "Morton’s neuroma (forefoot pain)",
            "Bunion pain (forefoot pain)",
            "Plantar fasciitis (rearfoot pain)",
        ],
    },
    {
        title: ["Biomedical Assessment and", "Treatment for Foot Condition"],
        lines: [],
    },
    {
        title: "Footwear Advice",
        lines: [],
    },
];

// title 可以是字符串，也可以是数组：数组里每一项单独占一行（用来手动控制长标题的换行位置）
function SpecialtyItem({title, lines}) {
    const titleLines = [].concat(title);
    return (
        <div className="mb-4">
            <div className="icon-box-content lh-lg">
                <h6 className="fw-bold fs-5">
                    {titleLines.map((part, index) => (
                        <React.Fragment key={part}>
                            {index > 0 && <br/>}
                            {part}
                        </React.Fragment>
                    ))}
                </h6>
                {lines.length > 0 && (
                    <ul className="text-secondary ps-4">
                        {lines.map((line) => (
                            <li key={line}>{line}</li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

function Specialties() {
    return (
        <div className="specialties-section">
            <div className="container-fluid my-5 pt-3 px-5">
                <div className="row">
                    <div className="col-md-8">
                        <div className="specialties-grid">
                            {specialties.map((item) => (
                                <SpecialtyItem key={[].concat(item.title).join(' ')} {...item}/>
                            ))}
                        </div>
                    </div>

                    <div className="col-md-4">
                        <h4 className="fs-3 text fw-bold">Main Specialties</h4>
                        <p><span className="text-accent-color font-weight-bold">We value our patients</span></p>
                        <p className="text-secondary">Podiatrists are in demand more than ever today due to a rapidly
                            growing and aging population.
                            <em><strong>To help you solve any foot issues you may have, feel free to contact
                                us.</strong></em></p>
                        <br/>
                        <a className="btn btn-warning rounded-pill text-white fs-3 fw-bold text px-4 py-3"
                           href="/information">More information</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Specialties;
